import { render } from "./PreferencesIcon.vue?vue&type=template&id=eba404b2&ts=true"
import script from "./PreferencesIcon.vue?vue&type=script&lang=ts"
export * from "./PreferencesIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__